import i18n from 'modules/core/lib/i18n'

import { BreakdownTransformedData } from 'modules/project_management/components/charts/EvolutionChart/BreakdownEvolutionChart/getCostBreakdownTransformedData'
import { EvolutionTransformedData } from 'modules/project_management/components/charts/EvolutionChart/getEvolutionTransformedData'
import { overviewFilterOptionsEnum, overviewFrequencyOptionsEnum } from './constants'

export type OverviewFilterOption = {
  label: string
  subtitle: string
  value: overviewFilterOptionsEnum
}

export type overviewFrequencyOption = {
  label: string
  value: overviewFrequencyOptionsEnum
}

export const currentWeekFilterOption = () => {
  return {
    label: i18n.t('project_management.graphs.filter_options.current_week'),
    subtitle: i18n.t('project_management.graphs.evolution.time.subtitles.current_week'),
    value: overviewFilterOptionsEnum.currentWeek,
  }
}

export const overviewFilterOptions = () => {
  return [
    currentWeekFilterOption(),
    {
      label: i18n.t('project_management.graphs.filter_options.last_week'),
      subtitle: i18n.t('project_management.graphs.evolution.time.subtitles.last_week'),
      value: overviewFilterOptionsEnum.lastWeek,
    },
    {
      label: i18n.t('project_management.graphs.filter_options.current_month'),
      subtitle: i18n.t('project_management.graphs.evolution.time.subtitles.current_month'),
      value: overviewFilterOptionsEnum.currentMonth,
    },
    {
      label: i18n.t('project_management.graphs.filter_options.last_month'),
      subtitle: i18n.t('project_management.graphs.evolution.time.subtitles.last_month'),
      value: overviewFilterOptionsEnum.lastMonth,
    },
    {
      label: i18n.t('project_management.graphs.filter_options.custom_range'),
      subtitle: i18n.t('project_management.graphs.evolution.time.subtitles.custom_range'),
      value: overviewFilterOptionsEnum.customRange,
    },
  ]
}

export const overviewFrequencyOptions = () => {
  return [
    {
      label: i18n.t('project_management.graphs.frequency_options.daily'),
      value: overviewFrequencyOptionsEnum.daily,
    },
    {
      label: i18n.t('project_management.graphs.frequency_options.weekly'),
      value: overviewFrequencyOptionsEnum.weekly,
    },
    {
      label: i18n.t('project_management.graphs.frequency_options.monthly'),
      value: overviewFrequencyOptionsEnum.monthly,
    },
    {
      label: i18n.t('project_management.graphs.frequency_options.yearly'),
      value: overviewFrequencyOptionsEnum.yearly,
    },
  ]
}

export const overviewFilterWholeProject = () => {
  return {
    label: i18n.t('project_management.graphs.filter_options.whole_project'),
    subtitle: i18n.t('project_management.graphs.evolution.time.subtitles.whole_project'),
    value: overviewFilterOptionsEnum.wholeProject,
  }
}

export const maxLengthOfLabelsArray = (
  selectedGranularity: overviewFrequencyOptionsEnum
): number => {
  switch (selectedGranularity) {
    case overviewFrequencyOptionsEnum.daily:
      return 8
    case overviewFrequencyOptionsEnum.weekly:
      return 6
    case overviewFrequencyOptionsEnum.monthly:
    case overviewFrequencyOptionsEnum.yearly:
      return 7
  }
}

export const dynamicFiltering = (
  dataValue: EvolutionTransformedData | BreakdownTransformedData,
  slotType: overviewFrequencyOptionsEnum
) => {
  const maxTicks = maxLengthOfLabelsArray(slotType)

  if (dataValue.data.length > maxTicks) {
    const interval = Math.ceil(dataValue.data.length / maxTicks)

    dataValue.data.forEach((item, index) => {
      if (index % interval !== 1) {
        item.title = ''
      }
    })
  }

  return dataValue
}
